// extracted by mini-css-extract-plugin
export default {"PersonalisationFlowContent":"PersonalisationFlowContent_PersonalisationFlowContent__4Nh3V","icon":"PersonalisationFlowContent_icon__D8bLD"};